import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-circle-progress-bar',
  templateUrl: './circle-progress-bar.component.html',
  styleUrls: ['./circle-progress-bar.component.css']
})
export class CircleProgressBarComponent implements OnInit {

  @Input() progressCompleted: number = 50;

  @Input() radius: any = 60;

  @Input() titleFont: any = 20;

  constructor() { }

  ngOnInit(): void {
  }

}
